<template>
  <div class="mt-8">
    <v-row>
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <!--Start: Registrants Tab-->
          <v-tab-item>
            <v-row dense>
              <v-col cols="12" class="d-flex justify-space-between">
                <div>
                  <v-icon>mdi-account</v-icon>
                  <span class="text-subtitle">{{ noOfRegistrants }}</span>
                </div>
                <div>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    single-line
                    hide-details
                    rounded
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-data-table
                  :headers="headers"
                  :items="linkRegistrants"
                  :search="search"
                  disable-pagination
                  hide-default-footer
                  class="mt-0"
                >
                  <template slot="no-data">
                    <div>You don't have any registrants yet</div>
                  </template>
                  <template v-slot:item.firstName="{ item }">
                    <v-list-item>
                      <UserAvatar
                        :key="item.businessCardId"
                        :usersInitials="
                          item.firstName[0] + ' ' + item.lastName[0]
                        "
                        :displayImageUrl="item.displayImageUrl"
                      />

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{
                            item.firstName + " " + item.lastName
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          item.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:item.jobTitle="{ item }">
                    {{ item.jobTitle != "" ? item.jobTitle : "-" }}
                  </template>
                  <template v-slot:item.company="{ item }">
                    {{
                      item.businessName != "" && item.businessName != undefined
                        ? item.businessName
                        : "-"
                    }}
                  </template>
                  <template v-slot:item.country="{ item }">
                    {{
                      item.country != "" && item.country != undefined
                        ? item.country
                        : "-"
                    }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      left
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list nav>
                        <v-list-item @click="showBusinessCardOnDevice(item)">
                          <v-list-item-title
                            >View business card</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item @click="handleRemove(item)">
                          <v-list-item-title
                            >Remove from link</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <!--Start: Business Card on device dialog-->
                <v-dialog
                  v-model="businessCardOnDeviceDialog"
                  width="300"
                  content-class="device-corners"
                >
                  <BusinessCardOnDevice
                    :title="deviceTitle"
                    :subtitle="deviceSubtitle"
                    :line1="deviceLine1"
                    :line2="deviceLine2"
                    :line3="deviceLine3"
                  />
                </v-dialog>
                <!--End: Business Card on device dialog -->

                <!--Start: Confirmation dialog-->
                <ConfirmationDialog
                  :show="showConfirmationDialog"
                  title="Remove registrant?"
                  content="Are you sure, you want to remove this registrant?"
                  @click="removeRegistrant"
                  @closeDialog="showConfirmationDialog = false"
                  buttonText="Remove"
                />
                <!--End: Confirmation dialog-->
              </v-col>
            </v-row>
          </v-tab-item>
          <!--End: Registrants Tab-->
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import UserAvatar from "@/components/UserAvatar";
import { mapActions, mapGetters } from "vuex";
import BusinessCardOnDevice from "@/components/BusinessCardOnDevice";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Utility from "@/shared/utility";
import {getAuth, getBusinessCardsDoc} from "@/shared/firebase_utils";

export default {
  created() {
    this.usersEmail = getAuth().currentUser.email;
    this.getUsersFullName = Utility.getUsersFullName;

    this.initializeLinkRegistrants(this.currentSubEvent.attendees);
  },
  components: {
    UserAvatar,
    BusinessCardOnDevice,
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "currentSubEvent"]),
    noOfRegistrants() {
      if (this.linkRegistrants.length != 1) {
        let suffix = this.tab == 0 ? "registrants" : "AskOffer/Notes";
        return this.linkRegistrants.length + " " + suffix;
      } else {
        let suffix = this.tab == 0 ? "registrant" : "AskOffer/Note";
        return this.linkRegistrants.length + " " + suffix;
      }
    },
  },
  watch: {
    "currentSubEvent.attendees": function (attendees) {
      //Add attendee to linkRegistrants
      attendees.forEach((attendee) => {
        if (attendee.businessCardId != "") {
          let isBusinessCardRetrieved = false;

          for (let i = 0; i < this.linkRegistrants.length; i++) {
            if (this.linkRegistrants[i].id == attendee.businessCardId) {
              isBusinessCardRetrieved = true;
              break;
            }
          }

          if (!isBusinessCardRetrieved) {

            getBusinessCardsDoc(attendee.businessCardId)
              .then((doc) => {
                let isPresent = false;

                for (let i = 0; i < this.linkRegistrants.length; i++) {
                  if (this.linkRegistrants[i].id == doc.id) {
                    isPresent = true;
                    this.linkRegistrants[i] = { id: doc.id, ...doc.data() };
                    break;
                  }
                }

                if (!isPresent)
                  this.linkRegistrants.push({ id: doc.id, ...doc.data() });
              });
          }
        }
      });

      //Remove attendee from linkRegistrants
      this.linkRegistrants.forEach((registrant, index) => {
        let isRegistrantRemoved = true;

        for (let i = 0; i < attendees.length; i++) {
          if (registrant.id == attendees[i].businessCardId) {
            isRegistrantRemoved = false;
            break;
          }
        }

        if (isRegistrantRemoved) this.linkRegistrants.splice(index, 1);
      });
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "firstName",
          align: "start",
        },
        { text: "Job Title", value: "jobTitle", align: "start" },
        { text: "Company", value: "company", align: "start" },
        { text: "Country", value: "country", align: "start" },
        { text: "Actions", value: "actions", align: "start" },
      ],
      search:'',
      deviceTitle: "",
      linkRegistrants: [],
      getUsersFullName: "",
      businessCardOnDeviceDialog: false,
      deviceTitle: "",
      deviceSubtitle: "",
      deviceLine1: "",
      deviceLine2: "",
      deviceLine3: "",
      removeRegistrantIndex: -1,
      showConfirmationDialog: false,
      tab: 0,
      askOfferNoteHeaders: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        { text: "Ask", value: "askText", align: "start", width: "25%" },
        { text: "Offer", value: "offerText", align: "start", width: "25%" },
        { text: "Note", value: "noteText", align: "start", width: "25%" },
      ],
    };
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    showBusinessCardOnDevice(businessCard) {
      window.open("https://app.pappyon.com/businessCard/" + businessCard.id);
    },

    handleRemove(registrant) {
      this.removeRegistrantIndex =
        this.currentEvent.attendees.indexOf(registrant);
      this.showConfirmationDialog = true;
    },

    removeRegistrant() {
      this.currentEvent.attendees.splice(this.removeRegistrantIndex, 1);
      this.currentEvent.save();
      this.showSnackbar({ show: true, text: "Removed successfully!" });
      this.showConfirmationDialog = false;
    },

    initializeLinkRegistrants(attendees) {
      attendees.forEach((attendee) => {
        if (attendee.businessCardId != "") {
          let isBusinessCardRetrieved = false;

          for (let i = 0; i < this.linkRegistrants.length; i++) {
            if (this.linkRegistrants[i].id == attendee.businessCardId) {
              isBusinessCardRetrieved = true;
              break;
            }
          }

          if (!isBusinessCardRetrieved) {

            getBusinessCardsDoc(attendee.businessCardId)
              .then((doc) => {
                if (doc.exists)
                  this.linkRegistrants.push({
                    id: doc.id,
                    ...attendee,
                    ...doc.data(),
                    invitedEmail: attendee.email,
                    invitedFirstName: attendee.firstName,
                    invitedLastName: attendee.lastName,
                  });
              });
          }
        }
      });

      //Remove attendee from linkRegistrants
      this.linkRegistrants.forEach((registrant, index) => {
        let isRegistrantRemoved = true;

        for (let i = 0; i < attendees.length; i++) {
          if (registrant.id == attendees[i].businessCardId) {
            isRegistrantRemoved = false;
            break;
          }
        }

        if (isRegistrantRemoved) this.linkRegistrants.splice(index, 1);
      });
    },
  },
};
</script>

<style>
.rotate-text {
  transform: rotate(-11.09deg) !important;
}

.whitespace-pre-line {
  white-space: pre-line !important;
  display: flex;
  align-items: flex-end;
}

.ask-offer-note-table tr td {
  vertical-align: top !important;
  padding: 0.5rem 0.5rem !important;
  cursor: pointer;
}
</style>
